import styled from "styled-components/macro";
import { Image } from "antd";

export const AvatarContainer = styled.div`
  margin-right: 40px;
`;

export const Avatar = styled(Image)`
  border-radius: 50%;
  object-fit: cover;
  display: inline-block;
`;
